import { render, staticRenderFns } from "./DataIModel.vue?vue&type=template&id=28a024a4&scoped=true"
import script from "./DataIModel.vue?vue&type=script&lang=js"
export * from "./DataIModel.vue?vue&type=script&lang=js"
import style0 from "./DataIModel.vue?vue&type=style&index=0&id=28a024a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a024a4",
  null
  
)

export default component.exports